// Fängt JS-Errors + unhandled Promise-Rejections + Resource-Loading-Errors
// und schickt sie ans Backend. Reine fire-and-forget.

import { API_BASE } from "./api";

const SENT_FINGERPRINTS = new Set<string>();
const MAX_QUEUE = 20;
let sent_in_session = 0;

function fingerprintOf(err: { message?: string; stack?: string }): string {
  const head = (err.stack || err.message || "").split("\n")[0].slice(0, 200);
  return head + ":" + (err.message?.slice(0, 80) || "");
}

function send(payload: { message: string; error_class?: string; stack?: string; url?: string }): void {
  try {
    const url = `${API_BASE}/public/errors`;
    const body = JSON.stringify(payload);
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      navigator.sendBeacon(url, blob);
      return;
    }
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* noop — error-reporter darf nichts crashen */
  }
}

function maybeReport(err: { message?: string; stack?: string; name?: string }, url?: string): void {
  if (!err || !err.message) return;
  // Hard rate-limit pro Session
  if (sent_in_session >= MAX_QUEUE) return;
  const fp = fingerprintOf(err);
  if (SENT_FINGERPRINTS.has(fp)) return;
  SENT_FINGERPRINTS.add(fp);
  sent_in_session += 1;
  send({
    message: err.message,
    error_class: err.name,
    stack: err.stack,
    url: url || window.location.href,
  });
}

export function installErrorReporter(): void {
  if (typeof window === "undefined") return;
  // Klassische Errors
  window.addEventListener("error", (event) => {
    // Resource-Loading-Errors (Bilder/Scripts) haben kein .error
    if (!event.error && event.target && event.target !== window) {
      const tgt = event.target as HTMLElement;
      const src = (tgt as HTMLImageElement | HTMLScriptElement).src || "";
      if (src) {
        maybeReport({
          message: `Resource failed to load: ${src.slice(0, 200)}`,
          name: "ResourceLoadError",
        });
      }
      return;
    }
    maybeReport({
      message: event.message || String(event.error?.message),
      stack: event.error?.stack,
      name: event.error?.name,
    });
  }, true);

  // Promise rejections
  window.addEventListener("unhandledrejection", (event) => {
    const reason: { message?: string; stack?: string; name?: string } | string | undefined = event.reason;
    if (!reason) return;
    if (typeof reason === "string") {
      maybeReport({ message: reason, name: "UnhandledRejection" });
    } else {
      maybeReport({
        message: reason.message || String(reason),
        stack: reason.stack,
        name: reason.name || "UnhandledRejection",
      });
    }
  });
}
